module.exports = __webpack_public_path__ + "static/media/Sutro.c0ce8510.png";